export const pathArr = location.pathname.split('/').filter((val) => val !== '');
export const APP_NAME = pathArr[0];
export const VIEW_NAME = pathArr[1];

const routeApp = `${APP_NAME}`;

const routeMap = {
  stocker: { api: 'stock' },
  sales: { api: 'order' },
  purchases: { api: 'purchases' },
}

/** PathObj = {
 * path: string,
 *   ${child_name}: {
 *     path: string,
 *     ${child_name}: ...
 *   } 
 * } */
type PathObj = Record<string, string | object>
const makeChild = (parent: string, child: object | string) => {
  let new_obj: PathObj = { path: parent }

  if (typeof child == 'string') {
    Object.assign(new_obj, {
      path: parent,
      [child]: { path: `${parent}${child}/` }
    })
  } else {
    Object.entries(child).forEach(([k, v]) => {
      const path = parent ? `${parent}${k}/` : `${k}/`
      Object.assign(new_obj, {
        path: parent,
        [k]: makeChild(path, v)
      })
    })
  }
  return new_obj
}
export const route = makeChild('', routeMap)


// << Accounts >>
export const routeAccounts = {
  userApi() { return '/mypage/api/user/' },
  businessPartnerApi(pk?: string) {
    return pk ? `/mypage/api/business-partner/${pk}/` : '/mypage/api/business-partner/'
  },
}



// << Stocker >>
export const routeStockerApp = {
  stockDetailPage(pk?: string) {
    return pk ? `/back-office/stocker/detail/${pk}/` : `/back-office/stocker/detail/`
  },
  slipApi(pk?: string) {
    const endpoint = pk ? `/back-office/stocker/api/slip/${pk}/` : `/back-office/stocker/api/slip/`;
    return endpoint
  },
  stockApi(pk?: string) {
    const endpoint = pk ? `/back-office/stocker/api/stock/${pk}/` : `/back-office/stocker/api/stock/`;
    return endpoint
  },
  stockForStockerApi(pk?: string) {
    const endpoint = pk ? `/back-office/stocker/api/stock_for_stocker/${pk}/` : `/back-office/stocker/api/stock_for_stocker/`;
    return endpoint
  },
  slipItemApi(pk?: string) {
    const endpoint = pk ? `/back-office/stocker/api/slip_item/${pk}/` : '/back-office/stocker/api/slip_item/';
    return endpoint
  },
  /*stockCategoryApi(pk?: string) {
    const endpoint = pk ? `/back-office/stocker/api/stock_category/${pk}/` : '/back-office/stocker/api/stock_category/';
    return endpoint
  }*/
};
